'use strict';
/**
 * @author Maxim Seredkin
 * @param {*} $rootScope
 * @param {*} $scope
 */
export default ['$rootScope', '$scope',
    function($rootScope, $scope) {
        $scope.setFilter = setFilter;
        $scope.selectAll = selectAll;

        init();

        // region Functions

        /**
         * Инициализация
         */
        function init() {
            $rootScope.title = 'Статусы сопровождения проекта';

            $scope.filter = {
                enabled: false,
                deleted: false,
            };

            _update();
        }

        /**
         * Обновить фильтра
         * @private
         */
        function _update() {
            $scope.filters = [];
            if ($scope.filter.enabled) {
                $scope.filters.push(`'status' EQ 'ENABLED'`);
            }
            if ($scope.filter.deleted) {
                $scope.filters.push(`'status' EQ 'DELETED'`);
            }
        }

        /**
         * Поменять значение фильтра
         */
        function setFilter() {
            _update();
        }

        /**
         * Выбрать все фильтра
         */
        function selectAll() {
            $scope.filter.enabled = true;
            $scope.filter.deleted = true;
            _update();
        }

        // endregion
    }];
